import * as Yup from 'yup';
const validationSchema =  Yup.object({
  busca: Yup.string(),
  filtro1: Yup.string(),
  filtro2: Yup.string(),
})

export default validationSchema;